import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import EventFinished from "src/components/EventFinished";
import TitleSection from "src/components/TitleSection/TitleSection";

const Cashnado2026 = () => {
  const { i18n, t } = useTranslation();

  return (
    <PageWrap>
      <Hero
        bgImage="promotions/gaming-machines/cashnado-2026/cashnado-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/gaming-machines/cashnado-2026/cashnado-logo-2400px-${i18n.language}.png`}
        imageAlt="CASHNADO - Win up to $250,000!"
        descriptionBgColor="rgba(0,0,0,0)"
        // frostedGlassPanel={t("cashnado2026.hero.frostedGlassPanel", {
        //   returnObjects: true,
        // })}
      />

      <EventFinished scheduleKeyName="cashnado2026" eventType="promotion" />

      <MainContent>
        <container-div>
          <TitleSection
            as="h1"
            title={t("cashnado2026.content.titleSection.title")}
            text={t("cashnado2026.content.titleSection.text")}
            borderColor="#cc0000"
            dark={true}
          />
        </container-div>
      </MainContent>
    </PageWrap>
  );
};

const PageWrap = styled.div`
  width: 100%;
  height: auto;
  background-color: var(--black);
  color: var(--white);

  .hero_text_container {
    display: none;
  }

  .hero_image_container {
    padding: 20px;
  }
`;

const MainContent = styled.div`
  height: auto;
  width: 100%;
  text-align: left;
  padding-bottom: 2rem;

  container-div {
    background: transparent;
  }

  .title-section {
    h1 {
      color: var(--white);
      text-transform: uppercase;
    }

    p {
      color: #cccccc;

      strong {
        color: var(--white);
      }
    }
  }
`;

export default Cashnado2026;
